import JobService from './jobService';
import ExpenseService from './expenseService';
import DepositService from './depositService';
import { computeFleetMetrics, FleetMetrics } from '../utils/aggregators';
import { ErrorLogger } from '../utils/errorLogger';

const EMPTY_METRICS: FleetMetrics = {
  totalIncome: 0, totalExpenses: 0, totalJobs: 0,
  cashJobs: 0, debtJobs: 0, cashAtHand: 0,
  moneyOwed: 0, incomeChange: 0, expensesChange: 0,
};

export class FleetMetricsService {
  static async getWeeklySnapshot(): Promise<FleetMetrics> {
    try {
      const [thisWeekJobs, allJobs, lastWeekJobs, weeklyExpenses, allExpenses, allDeposits] =
        await Promise.all([
          JobService.getCompletedJobsThisWeek(),
          JobService.getAllCompletedJobs(),
          JobService.getCompletedJobsLastWeek(),
          ExpenseService.getExpensesThisWeek(),
          ExpenseService.getAllExpenses(),
          DepositService.getAllDeposits(),
        ]);

      return computeFleetMetrics(
        thisWeekJobs, allJobs, weeklyExpenses, allExpenses, allDeposits, lastWeekJobs,
      );
    } catch (error) {
      ErrorLogger.logError(error, 'FleetMetricsService.getWeeklySnapshot');
      return { ...EMPTY_METRICS };
    }
  }
}

export default FleetMetricsService;
